var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPlayerVolume = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 1.4,
    d: "M9.55.94v0L4.8 4.69v0H1v5.625h3.8v0l4.75 3.75v0V.94v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 1.4,
    d: "M13.86 10.808a4.662 4.662 0 0 0 0-6.629m3.359 9.947a9.3 9.3 0 0 0 0-13.256"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPlayerVolume);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico-player-volume.01a116bcf0352521729769ccaecca11a.svg";